import { setShowOrderModal } from '../State/showProjectModal';

export default () => async (dispatch) => {
  dispatch(setShowOrderModal(false));
}